import React from 'react';
import loading from '@assets/icons/loading.svg';
import { LinearProgress, styled } from '@mui/material';

export const LoadingIndicator = () => {
  return (
    <div className="w-100 my-5">
      <img className="d-block mx-auto" src={loading} alt="loading icon" />
    </div>
  );
};

export const LoadingBarIndicator = () => {
  const CustomLinearProgress = styled(LinearProgress)`
    height: 5px;
    background-color: var(--inactive);
    & .MuiLinearProgress-bar {
      background-color: var(--primary-color);
    }
  `;

  return <CustomLinearProgress />;
};
